import React, { useState, useEffect } from 'react'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'
import { Box, Typography, styled, CircularProgress, Paper } from '@mui/material'
import { SectionsHeading } from '../../../../../components/headings'
import lightTheme from '../../../../../styles/theme/lightTheme'
import { keyframes } from '@emotion/react'
import '../../../../../styles/components/_slick.scss'
import { useTranslation } from 'react-i18next'
import Api from '../../../../../services/api.service'
import { handlingErrors } from '../../../../../utils'
import { Markup } from 'interweave'

const BoxItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  rowGap: '15px',
  /*width: 200,

  [theme.breakpoints.up("sm")]: {
    rowGap: "25px",
    width: 290,
  },

  [theme.breakpoints.up("sm")]: {
    width: 570,
  },*/
}))

const TitleComment = styled(Typography)(({ theme }) => ({
  fontFamily: 'Century Gothic Bold',
  fontSize: 12,
  lineHeight: '140%',
  letterSpacing: '0.2px',
  color: lightTheme.palette.text.primary,
  textTransform: 'uppercase',

  [theme.breakpoints.up('sm')]: {
    fontSize: 14,
  },

  [theme.breakpoints.up('lg')]: {
    fontSize: 18,
  },
}))

const FonctionComment = styled(Typography)(({ theme }) => ({
  fontFamily: 'Century Gothic',
  fontSize: 10,
  lineHeight: '140%',
  letterSpacing: '0.2px',
  color: lightTheme.palette.grey.grey,
  fontStyle: 'italic',

  [theme.breakpoints.up('sm')]: {
    fontSize: 12,
  },

  [theme.breakpoints.up('lg')]: {
    fontSize: 14,
  },
}))

const SeparatePoint = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  columnGap: '15px',

  span: {
    width: 10,
    height: 10,
    borderRadius: '100px',
    backgroundColor: lightTheme.palette.error.main,
    animation: `${colorEffect} 15s linear infinite`,
  },
}))

const colorEffect = keyframes`
    0% { background-color: #F76E11;}
    25% { background-color: #96CEB4; }
    50% { background-color: #808BF8; }
    75% { background-color: #96CEB4; }
    100% { background-color: #F76E11;}
`

const ConsultantSection = () => {
  const { t, i18n } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [consultants, setConsultants] = useState([])

  let settings = {
    className: 'center',
    centerMode: true,
    infinite: true,
    centerPadding: '0px',
    slidesToShow: 3,
    speed: 3000,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerPadding: '0',
        },
      },
      {
        breakpoint: 900,
        settings: {
          centerPadding: '350px',
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerPadding: '100px',
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          centerPadding: '50px',
          slidesToShow: 1,
        },
      },
    ],
  }

  useEffect(() => {
    getConsultants()
  }, [])

  const getConsultants = async () => {
    setLoading(true)

    try {
      const result = await Api.siteVitrine.getConsultants(i18n.language)
      const res = handlingErrors(result)

      if (res.status === 401) {
        console.log('erreur')
      }

      if (res.ok) {
        setConsultants(res.data)
      }
      setLoading(false)
    } catch (error) {
      console.log('erreur')
    }
  }

  if (loading) {
    return (
      <div
        style={{
          maxWidth: '100%',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          rowGap: '75px',
          padding: '100px 0',
        }}
      >
        <CircularProgress />
      </div>
    )
  }

  return (
    <div
      style={{
        maxWidth: '100%',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        rowGap: '75px',
        padding: '100px 0',
      }}
    >
      <SectionsHeading
        type={'animation'}
        display={'flex'}
        justifyContent={'center'}
        textAlign={'center'}
      >
        {t('candidats.testimonials')}
      </SectionsHeading>
      <Slider {...settings}>
        {consultants.map((item, index) => (
          <Box key={index} px={2}>
            <Paper
              className="testimonial-card"
              elevation={0}
              sx={{
                p: 4,
                borderRadius: 4,
                textAlign: 'center',
                position: 'relative',
                background: 'linear-gradient(135deg, #f9fafb, #ffffff)',
                border: '1px solid #eee',
                height: '100%',
              }}
            >
              {/* Quote icon */}
              {/* <Typography
                sx={{
                  fontSize: '60px !important',
                  position: 'absolute',
                  top: 10,
                  left: 20,
                  opacity: 0.8,
                }}
              >
                “
              </Typography> */}

              {/* Avatar */}
              {false && item.photo && (
                <Box
                  component="img"
                  src={item.photo}
                  sx={{
                    width: 90,
                    height: 90,
                    borderRadius: '50%',
                    objectFit: 'cover',
                    mx: 'auto',
                    mb: 2,
                    border: '3px solid #fff',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                  }}
                />
              )}

              {/* Auteur */}
              <Typography variant="subtitle1" fontWeight={600}>
                {item.nom}
              </Typography>

              <Typography variant="body2">{item.fonction}</Typography>

              {/* Séparateur */}
              <Box
                sx={{
                  width: 40,
                  height: 3,
                  backgroundColor: 'primary.main',
                  mx: 'auto',
                  mb: 2,
                  mt: 2,
                  borderRadius: 2,
                }}
              />

              {/* Texte (citation style) */}
              <Typography
                variant="body1"
                sx={{
                  fontStyle: 'italic',
                  color: '#444',
                  lineHeight: 1.8,
                  mb: 3,
                }}
              >
                <Markup content={item.descriptif} />
              </Typography>
            </Paper>
          </Box>
        ))}
      </Slider>
    </div>
  )
}

export default ConsultantSection
